/* mb-testimonials.js
 * Adds prev/next arrows to the homepage "Your own words" testimonial
 * carousel (.mb-com__slider) when it overflows its container. Pure
 * progressive enhancement — the carousel swipes/scrolls natively even
 * without this script.
 *
 * (Extracted from the old mb-gallery-peek.js. The product-page gallery
 * is now native Dawn and needs no custom JS, so only the testimonial
 * helper remains.)
 */
(function () {
  'use strict';

  function setupTestimonials() {
    document.querySelectorAll('.mb-com__slider').forEach(function (slider) {
      if (slider.__mbComInit) return;
      if (slider.scrollWidth <= slider.clientWidth + 10) return;
      slider.__mbComInit = true;

      var wrap = slider.closest('.mb-com__slider-wrap') || slider.parentElement;
      if (getComputedStyle(wrap).position === 'static') wrap.style.position = 'relative';

      function arrow(cls, label, dPath) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'mb-com-nav ' + cls;
        b.setAttribute('aria-label', label);
        b.innerHTML = '<svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true"><path d="' + dPath + '" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
        return b;
      }
      function step() {
        var c = slider.querySelector('.mb-com__card, .mb-com__panel');
        return (c ? c.getBoundingClientRect().width : 300) + 26;
      }

      var prev = arrow('mb-com-prev', 'Previous review', 'M15 5 L8 12 L15 19');
      var next = arrow('mb-com-next', 'Next review', 'M9 5 L16 12 L9 19');
      prev.addEventListener('click', function () { slider.scrollBy({ left: -step(), behavior: 'smooth' }); });
      next.addEventListener('click', function () { slider.scrollBy({ left: step(), behavior: 'smooth' }); });
      wrap.appendChild(prev);
      wrap.appendChild(next);
    });
  }

  if (document.readyState !== 'loading') setupTestimonials();
  else document.addEventListener('DOMContentLoaded', setupTestimonials);
  window.addEventListener('resize', setupTestimonials);
  document.addEventListener('shopify:section:load', setupTestimonials);
})();
